import { CopyButton } from "../../CopyButton";
import { IModalTopSectionProps } from "./ModalTopSection";

export const View = (props: IModalTopSectionProps) => {
  return (
    <div className="modal-top-section flex-container col payment-details-modal">
      <div className="modal-top">
        <div className="flex-container row flex-break--small">
          <div className="flex-box">
            <div className="modal-header--title">{props.header}</div>
            <div className="modal-header--subtitle">{props.subHeader}</div>
          </div>

          {!props.copyText ? null : (
            <div className="flex-container col justify-content--end align-items--start">
              <div className="flex-container justify-content--start align-items--center">
                {!props.copyContent ? null : (
                  <div className="copy-button--container">
                    <CopyButton
                      className="copy-btn"
                      stringToCopy={props.copyContent}
                    />
                  </div>
                )}
                {!props.copyText ? null : (
                  <div className="transaction-id-text modal-header--title">
                    {props.copyText}
                  </div>
                )}
              </div>
              {!props.copyContent ? null : (
                <div className="float-down actual-transaction-id">
                  {props.copyContent}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
